import { ArrayInput, SimpleFormIterator, TextInput, required, useRecordContext } from "react-admin";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { validateAdditionalHouseholdMembers } from "../sabil-household-members";
import { SABIL_ITS_CLOSED_HELPER, SABIL_ITS_CORRECTION_HELPER } from "../sabil-its-correction";

/**
 * Mutawatteen additional family editor. The holder is entered on the sabil block above;
 * this ArrayInput is for extra members only.
 */
export function SabilHouseholdMembersInput() {
  const record = useRecordContext();
  const isClosed = Boolean(record?.closedAt);

  return (
    <>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, mb: 0.5 }}>
        Additional family members
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
        Optional — add other family members with ITS numbers. The sabil holder is entered above.
        WhatsApp is optional and used for RSVP invites when present.
        {record?.id ? ` ${SABIL_ITS_CORRECTION_HELPER}` : null}
      </Typography>
      <ArrayInput
        source="householdMembers"
        label={false}
        validate={validateAdditionalHouseholdMembers}
        defaultValue={[]}
      >
        <SimpleFormIterator
          fullWidth
          sx={{
            "& .RaSimpleFormIterator-form": {
              width: "100%",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              p: 1.5,
              my: 1,
              bgcolor: "background.paper",
            },
          }}
        >
          <Grid container spacing={1} sx={{ width: "100%", alignItems: "center" }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextInput source="name" label="Name" validate={[required()]} fullWidth />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <TextInput
                source="itsNo"
                label="ITS"
                validate={[required()]}
                fullWidth
                disabled={isClosed}
                helperText={isClosed ? SABIL_ITS_CLOSED_HELPER : "Required for each family member"}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 5 }}>
              <TextInput
                source="whatsappNo"
                label="WhatsApp (optional)"
                placeholder="+919876543210"
                fullWidth
                helperText="Optional — E.164 format with '+' prefix (e.g. +919876543210)"
              />
            </Grid>
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
}
